import React from 'react';
import ArticleSearchResults from '../Articles/ArticleSearchResults';
import ProductSearchResults from '../Products/ProductSearchResults';
import PropTypes from 'prop-types';
import {
    ARTICLES,
    PRODUCTS
} from '../../constants/index.js';
import WithLoading from '../../components/WithLoading';
import { Nav, NavItem, NavLink, TabContent, TabPane, Card, CardHeader, CardBody } from 'reactstrap';
import { translateResourceString } from '../../../util/translationUtility.js';

const CombinedSearchResults = ({ articles,
    articlePaginationViewModel,
    onArticleCurrentItemsPerPageChange,
    onArticleCurrentPageIndexChange,
    onResultClick,
    attributes,
    productAttributes,
    onAttributeChange,
    onProductAttributeChange,
    onClearAttributes,
    onProductCurrentItemsPerPageChange,
    onProductCurrentSortByChange,
    onArticleCurrentSortByChange,
    onProductCurrentPageIndexChange,
    productPaginationViewModel,
    products,
    view,
    onChangeView,
    isLoading,
    onShowMobileFacetsChange,
    expandedArticleFacets,
    expandedProductFacets,
    onToggleFacetExpanded,
    onToggleProductFacetExpanded,
    showMoreFacets,
    onToggleShowMoreFacet,
    disableProducts
}) => {
    const showArticles = view === ARTICLES || disableProducts;
    const showProducts = !showArticles;

    return (
        <div className="row combined-search-wrapper">
            <div className="col-md-12">
                <div className="nav nav-tabs card-header-tabs">

                    <NavItem>
                        <NavLink
                            className={showArticles ? "active" : ""}
                            onClick={()=>onChangeView(ARTICLES)}
                            href="#"
                        >
                            {translateResourceString("/SearchApp/Content")}
                        </NavLink>
                    </NavItem>
                    {!disableProducts &&
                    <NavItem>
                        <NavLink
                            className={showProducts ? "active" : ""}
                            onClick={()=>onChangeView(PRODUCTS)}
                            href="#"
                        >
                            {translateResourceString("/SearchApp/Products")}
                        </NavLink>
                    </NavItem>
                    }
                </div>

                <TabContent activeTab={view}>
                    <TabPane tabId={ARTICLES}>
                        <ArticleSearchResultsWithLoading
                            articles={articles}
                            paginationViewModel={articlePaginationViewModel}
                            onResultClick={onResultClick}
                            isLoading={isLoading}
                            attributes={attributes}
                            onAttributeChange={onAttributeChange}
                            onCurrentSortByChange={onArticleCurrentSortByChange}
                            expandedArticleFacets={expandedArticleFacets}
                            onToggleShowMoreFacet={onToggleShowMoreFacet}
                            onToggleFacetExpanded={onToggleFacetExpanded}
                            showMoreFacets={showMoreFacets}
                            />
                    </TabPane>
                    {!disableProducts &&
                    <TabPane tabId={PRODUCTS}>
                        <ProductSearchResultsWithLoading
                            attributes={productAttributes}
                            onAttributeChange={onProductAttributeChange}
                            onClearAttributes={onClearAttributes}
                            onCurrentItemsPerPageChange={onProductCurrentItemsPerPageChange}
                            onCurrentSortByChange={onProductCurrentSortByChange}
                            onCurrentPageIndexChange={onProductCurrentPageIndexChange}
                            paginationViewModel={productPaginationViewModel}
                            products={products}
                            onResultClick={onResultClick}
                            isLoading={isLoading}
                            showMobileFacets={onShowMobileFacetsChange}
                            onShowMobileFacetsChange={onShowMobileFacetsChange}
                            expandedFacets={expandedProductFacets}
                            onToggleFacetExpanded={onToggleProductFacetExpanded}
                            showMoreFacets={showMoreFacets}
                            onToggleShowMoreFacet={onToggleShowMoreFacet}
                        />
                    </TabPane>
                    }
                </TabContent>
            </div>
        </div>
    );
};

const ArticleSearchResultsWithLoading = WithLoading(ArticleSearchResults);
const ProductSearchResultsWithLoading = WithLoading(ProductSearchResults);

CombinedSearchResults.propType = {
    articles: PropTypes.arrayOf(
        PropTypes.shape({
            Title: PropTypes.string,
            Link: PropTypes.string,
            Description: PropTypes.string
        })
    ),
    articlePaginationViewModel: PropTypes.shape({
        CurrentPageIndex: PropTypes.number,
        CurrentItemsPerPage: PropTypes.number,
        ResultsTotal: PropTypes.number,
        CurrentItemsOnPage: PropTypes.number
    }),
    onArticleCurrentItemsPerPageChange: PropTypes.func,
    onArticleCurrentPageIndexChange: PropTypes.func,
    onResultClick: PropTypes.func,
    attributes: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        DisplayName: PropTypes.string,
        Values: PropTypes.arrayOf(PropTypes.shape({
            Name: PropTypes.string,
            Checked: PropTypes.bool,
            Count: PropTypes.number
        }))
    })),
    productAttributes: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        DisplayName: PropTypes.string,
        Values: PropTypes.arrayOf(PropTypes.shape({
            Name: PropTypes.string,
            Checked: PropTypes.bool,
            Count: PropTypes.number
        }))
    })),
    onAttributeChange: PropTypes.func,
    onClearAttributes: PropTypes.func,
    onProductCurrentItemsPerPageChange: PropTypes.func,
    onProductCurrentSortByChange: PropTypes.func,
    onProductCurrentPageIndexChange: PropTypes.func,
    productPaginationViewModel: PropTypes.shape({
        ResultsTotal: PropTypes.number,
        CurrentItemsPerPage: PropTypes.number,
        CurrentPageIndex: PropTypes.number,
        CurrentSortBy: PropTypes.string,
        CurrentItemsOnPage: PropTypes.number
    }),
    products: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        Url: PropTypes.string,
        Image: PropTypes.shape({
            Url: PropTypes.string,
            Alt: PropTypes.string
        }),
        Description: PropTypes.string,
        Formats: PropTypes.string,
        Languages: PropTypes.string
    })),
    view: PropTypes.string,
    onChangeView: PropTypes.func,
    onShowMobileFacetsChange: PropTypes.func.isRequired,
    expandedArticleFacets: PropTypes.arrayOf(PropTypes.string),
    expandedProductFacets: PropTypes.arrayOf(PropTypes.string),
    onToggleFacetExpanded: PropTypes.func,
    onToggleProductFacetExpanded: PropTypes.func,
    showMoreFacets: PropTypes.arrayOf(PropTypes.string),
    onToggleShowMoreFacet: PropTypes.func,
    disableProducts: PropTypes.bool
};

export default CombinedSearchResults;
